import { DeviceType } from '@birco/rainmesh-api';
import { RouteConstants } from '../constants/route-constants';

export function getDeviceDetailRoute(
  device: { id: string; type?: DeviceType | null },
): [string, string, string] {
  return device.type === DeviceType.PUMP
    ? ['/', RouteConstants.routePump, device.id]
    : ['/', RouteConstants.routeDevice, device.id];
}
